<template>
    <div class="driver-expense-unfreeze">
        <m-pane ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            moduleCode="driverExpenseUnfreezeLSP"
            searchId="driverExpenseUnfreezeQuery"
            pageID="driverExpenseUnfreeze">
            <div slot="table-top" class="table-module-tips2">
                费用释放说明：发车单分账状态为已分账（线下支付也须分账，支付对象选择“其他”)、分账支付状态为已支付，且司机收款确认状态为已确认收到的费用，可以解冻释放。解冻释放状态为“已释放”的费用，可以在美的付发起提现。
            </div>
            <template #table-module-btn>
                <reportExport
                    #default="{ submit }"
                    reportCode="DRIVER_EXPENSE_UNFREEZE_EXPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'driver-expense-unfreeze-export'" class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                :disabled="!pageTotal"
                                class="bigData-btn-driver-expense-unfreeze-export"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </template>
            <template #page-module-btn>
                <el-button
                    v-has="'driver-expense-unfreeze-release'"
                    type="primary"
                    @click="handleReleaseCosts"
                >释放费用</el-button>
                <el-button
                    v-has="'driver-expense-unfreeze-update-release'"
                    type="primary"
                    @click="updateReleaseStatus"
                >更新释放状态</el-button>
                <div class="norelease-amount"><span>未释放金额: {{ amount }} 元</span></div>
            </template>
        </m-pane>

        <!-- 释放费用弹窗 -->
        <release-fee-dialog
            v-if="releaseFeeDialogShow"
            :releaseFeeDialogShow.sync="releaseFeeDialogShow"
            :supplier="supplier"
            @refresh="refresh"
        ></release-fee-dialog>

        <!-- 更新释放状态弹窗 -->
        <update-release-status-dialog
            v-if="updateReleaseStatusDialogShow"
            :updateReleaseStatusDialogShow.sync="updateReleaseStatusDialogShow"
            :supplier="supplier"
            @refresh="refresh"
        ></update-release-status-dialog>
    </div>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import { carrierFeeThawingQueryPage, queryCount, queryUnThawingAmount } from '@/modules/transport/otp/api/driverExpenseUnfreezeAndBalance.js';
import reportExport from '@/components/lots/reportExportPlugin';
import { formatSearchData, validateSearchData, removeFalsyValues } from './util.js';
import { mapState } from 'vuex';
export default {
    name: 'driverExpenseUnfreeze',
    components: {
        mPane,
        reportExport,
        releaseFeeDialog: () => import('./components/releaseFeeDialog.vue'),
        updateReleaseStatusDialog: () => import('./components/updateReleaseStatusDialog.vue')
    },
    data() {
        return {
            config,
            loading: false,
            selectedList: [],
            totalData: [],
            pageTotal: 0,
            amount: 0,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            releaseFeeDialogShow: false,
            updateReleaseStatusDialogShow: false
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
        })
    },
    methods: {
        // 刷新页面
        refresh () {
            this.getList();
        },
        // 选中表格行
        selectChange (data) {
            this.selectedList = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...removeFalsyValues(data),
                    carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
                }
            };
            return _searchData;
        },
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData);
            if (!isQueryOk) return;
            this.searchParams = this.getSearchData(_searchData);
            this.getList();
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        async getList () {
            this.loading = true;
            const params = {
                ...this.searchParams
            };
            this.getListPageCount();
            this.queryUnThawingAmount();
            carrierFeeThawingQueryPage(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        const { list } = res.data;
                        this.totalData = list || [];
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getListPageCount() {
            queryCount(this.searchParams.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        async queryUnThawingAmount() {
            const res = await queryUnThawingAmount(this.searchParams.param);
            if (res && +res.code === 0) {
                this.amount = res.data || 0;
            }
        },
        exportFile(submit) {
            const exportParams = {
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00',
                carrierCodeList: [this.supplier.supplierCode], // 供应商编码-LSP
                ...this.searchParams.param
            };
            submit(exportParams);
        },
        // 释放费用
        handleReleaseCosts() {
            this.releaseFeeDialogShow = true
        },
        // 更新释放状态
        updateReleaseStatus() {
            this.updateReleaseStatusDialogShow = true
        }
    }
};

</script>
<style lang='less' scoped>
.driver-expense-unfreeze {
    .table-module-tips2 {
        margin-bottom: 8px;
        color: #D9001B;
        font-size: 11px;
    }
    .norelease-amount {
        margin-left: 10px;
        color: #D9001B;
    }
    /deep/.otp-table {
        .el-table {
            min-height: calc(~'100vh - 248px') !important;
            max-height: calc(~'100vh - 248px') !important;
            .el-table__fixed {
                height: calc(100% - 14px) !important;
            }
        }
    }
}

</style>
